import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M5.625 0a5.62 5.62 0 0 0-3.977 1.652A5.65 5.65 0 0 0 0 5.641v13.161c0 1.496.593 2.93 1.648 3.989a5.62 5.62 0 0 0 3.977 1.652v3.675a1.88 1.88 0 0 0 1.05 1.69 1.87 1.87 0 0 0 1.976-.204l6.617-5.161h9.107a5.62 5.62 0 0 0 3.977-1.652A5.65 5.65 0 0 0 30 18.802V5.641c0-1.496-.593-2.931-1.648-3.989A5.62 5.62 0 0 0 24.376 0zm.469 14.572a1.41 1.41 0 0 1 1.406-1.41h10.313a1.404 1.404 0 0 1 1.406 1.41 1.41 1.41 0 0 1-1.407 1.41H7.5a1.404 1.404 0 0 1-1.406-1.41M7.5 7.52a1.404 1.404 0 0 0-1.406 1.41 1.41 1.41 0 0 0 1.406 1.41h15a1.404 1.404 0 0 0 1.406-1.41 1.41 1.41 0 0 0-1.406-1.41z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }